import Immutable from 'immutable';
import moment from 'moment';

import { itemToMoment } from 'sharedreact/utils/MomentSupport';

const Content: {
  id: string,
  host: string,
  remoteHost: string,
  viewEngine: string,
  user: string,
  documents: Immutable.List<string> | null,
  startedDate: moment.Moment | null
} = {
  id: '',
  host: '',
  remoteHost: '',
  viewEngine: '',
  user: '',
  documents: null,
  startedDate: null
};

class ViewSession extends Immutable.Record(Content) {
  static fromJS (json: object): ViewSession {
    return new ViewSession(Immutable.Map<string, unknown>(json).map(itemToMoment));
  }

  get name (): string {
    return this.host;
  }
}

export default ViewSession;
